import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["navbar", "gradient", "scrollOverlay", "mobileMenu", "mobileMenuButton"]

  connect() {
    this.bindEvents()
    this.handleScroll()
  }

  disconnect() {
    this.unbindEvents()
  }

  bindEvents() {
    // Scroll events
    window.addEventListener('scroll', this.throttledScroll.bind(this))

    // Close mobile menu when clicking outside
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  unbindEvents() {
    window.removeEventListener('scroll', this.throttledScroll.bind(this))
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }
  // Stimulus actions
  toggle() {
    this.mobileMenuTarget.classList.toggle('hidden')
  }

  close() {
    if (this.hasMobileMenuTarget) {
      this.mobileMenuTarget.classList.add('hidden')
    }
  }

  handleScroll() {
    // Use lenis.scroll from Stimulus-controlled Lenis for smoother interactions
    const scrollY = window.lenis ? window.lenis.scroll : window.scrollY
    const maxScroll = 100
    const scrollRatio = Math.min(scrollY / maxScroll, 1)

    if (this.hasGradientTarget) {
      this.gradientTarget.style.opacity = Math.max(0, 1 - scrollRatio * 2)
    }

    if (this.hasScrollOverlayTarget) {
      this.scrollOverlayTarget.style.opacity = scrollRatio
    }

    if (this.hasNavbarTarget) {
      if (scrollY > 50) {
        this.navbarTarget.style.backdropFilter = 'blur(8px)'
      } else {
        this.navbarTarget.style.backdropFilter = 'none'
      }
    }
  }

  throttledScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.handleScroll()
        this.ticking = false
      })
      this.ticking = true
    }
  }


  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
